import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MessagingService } from "../services/messaging.service";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _customer: string = "";
  private _apiKey: string = "";
  private authenticated: boolean = false;

  public get customer() {
    return this._customer || "";
  }
  public get apiKey(): string {
    return this._apiKey || "";
  }
  private nextUrl: string = "./Libraries";

  constructor(private router: Router, private location: Location, private http: HttpClient, private messagingService: MessagingService) { }

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  authenticate(customer: string, apiKey: string, nextUrl?:string) {
    this._customer = customer;
    this._apiKey = apiKey;
    if (nextUrl !== undefined) this.nextUrl = nextUrl;
    else this.nextUrl = this.nextUrl || "./Libraries";
    this.login();
  }

  ensureAuthentication() {
    if (this.location.path(true) == "") return;

    this.nextUrl = this.location.path(true);
    if (!this.authenticated) this.router.navigate(['']);
  }

  login() {
    if (!this._customer || !this.apiKey) return;

    const url = `/api/${this._customer}/authenticate?apiKey=${this.apiKey}`;
    this.http.get(url).subscribe({
      next: (result: any) => {
        this.authenticated = true;
        if (this.nextUrl) this.router.navigate([this.nextUrl]);
      },
      error: (error: any) => {
        if (error.status == 401) return this.messagingService.showHttpError("error", "Invalid Credentials", "Try again");
        else this.messagingService.showHttpError("error", error.error, "Correct and Try again");
      }
    });
  }
}
